import React from "react";
import { useI18n } from "../lib/i18n";
import { CheckCircle2, XCircle, Circle, Loader } from "lucide-react";

export default function WorkflowStepper({ workflow, currentIndex }) {
  const { t } = useI18n();
  return (
    <div
      className="w-full overflow-x-auto scroll-thin"
      data-testid="workflow-stepper"
    >
      <div className="flex items-stretch min-w-max">
        {workflow.map((step, idx) => {
          const isCurrent = idx === currentIndex && step.status === "pending";
          const isOk = step.status === "ok";
          const isNotOk = step.status === "not_ok";
          const isDone = isOk || isNotOk;
          const isPending = !isDone && !isCurrent;

          let bg = "bg-slate-100 border-slate-300 text-slate-500";
          let Icon = Circle;
          if (isOk) {
            bg = "bg-emerald-50 border-emerald-400 text-emerald-700";
            Icon = CheckCircle2;
          } else if (isNotOk) {
            bg = "bg-red-50 border-red-400 text-red-700";
            Icon = XCircle;
          } else if (isCurrent) {
            bg = "bg-[#E0F2FE] border-[#004D99] text-[#004D99]";
            Icon = Loader;
          }

          return (
            <div
              key={idx}
              className="flex items-center"
              data-testid={`step-${step.role}`}
            >
              <div
                className={`flex flex-col items-center px-4 py-3 rounded-lg border-2 ${bg} min-w-[180px]`}
              >
                <Icon
                  className={`w-6 h-6 mb-1 ${isCurrent ? "animate-spin-slow" : ""}`}
                  aria-hidden="true"
                />
                <div className="font-mono text-[10px] tracking-widest opacity-70">
                  STEP {idx + 1}
                </div>
                <div className="text-xs font-bold text-center mt-0.5">
                  {t(`role_label.${step.role}`)}
                </div>
                {step.assignee && (
                  <div className="text-[10px] text-slate-600 mt-0.5 truncate max-w-[160px]">
                    {step.assignee.full_name}
                  </div>
                )}
                <div className="text-[10px] mono mt-1 uppercase">
                  {step.status}
                </div>
              </div>
              {idx < workflow.length - 1 && (
                <div
                  className={`h-1 w-8 ${
                    isDone ? "bg-emerald-300" : "bg-slate-200"
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
